import { drProfileClient } from '@/common/apis/client';
import { useQuery } from '@tanstack/react-query';
import { parseDoctorCenters } from './parseDoctorCenters';

/** Definitive "no doctor record" from drprofile (HTTP 400/404). Array = centers, null = unknown. */
export const CENTERS_USER_NOT_FOUND: { readonly notFound: true } = { notFound: true };

export const isCentersUserNotFound = (result: unknown): boolean =>
  !!result && !Array.isArray(result) && (result as { notFound?: boolean }).notFound === true;

export const getCentersByUserId = async (user_id: string) => {
  try {
    const { data } = await drProfileClient.get(`/api/users/${user_id}/centers`);
    return parseDoctorCenters(data);
  } catch (error) {
    const status = (error as { response?: { status?: number } } | null)?.response?.status;
    if (status === 400 || status === 404) return CENTERS_USER_NOT_FOUND;
    return null;
  }
};

/** Result is `unknown[] | null | CENTERS_USER_NOT_FOUND` — check Array.isArray or isCentersUserNotFound before use. */
export const useGetCentersByUserId = (user_id: string, options?: any) => {
  return useQuery(['getCentersByUserId', user_id], () => getCentersByUserId(user_id), {
    ...options,
    retry: 3,
    retryDelay: 1000,
  });
};
